module.exports = __webpack_public_path__ + "img/SER-B-2-V.50a4905e.png";